import { fetcher } from "@website/fetcher/fetcher";
import {
  AuthB2BRequestOtpBodyType,
  AuthB2BRequestOtpResponseType
} from "@website/widget/login/services/auth-b2b-request-otp/auth-b2b-request-otp.types";

export const AuthB2BRequestOtpUrl = `${process.env.NEXT_PUBLIC_BASE_URL_PLATFORM}/profile/b2b/auth/request-otp`;

export const AuthB2BRequestOtpService = (
  body: AuthB2BRequestOtpBodyType
): Promise<AuthB2BRequestOtpResponseType> =>
  fetcher({
    url: AuthB2BRequestOtpUrl,
    method: "POST",
    data: body
  }).then(({ data }) => data);
